import React from "react";

import styles from "./CheckBox.module.css";
import { generateUUID } from "common-ui-components/components/utils/string-utils";

const CheckBox = ({ label = "", scaleIcon, ...rest }) => {
  const checkBoxId = `cbx-${label
    .replace(/\s/g, "-")
    .toLowerCase()}-${generateUUID()}`;

  return (
    <div className={styles.checkbox_wrapper_46}>
      <input
        type="checkbox"
        id={checkBoxId}
        className={styles.inp_cbx}
        {...rest}
      />
      <label htmlFor={checkBoxId} className={styles.cbx}>
        <span style={{ transform: `scale(${scaleIcon})` }}>
          <svg viewBox="0 0 12 10" height="10px" width="12px">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>
        <span>{label}</span>
      </label>
    </div>
  );
};

export default CheckBox;
